var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLedigeStillinger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "33px",
    viewBox: "0 0 34 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color/32-content/box-2 Copy 3@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning",
    transform: "translate(-309.000000, -5044.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/01-edition/search",
    transform: "translate(309.000000, 5044.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.04224,24.08448 C5.39149449,24.08448 0,18.6929855 0,12.04224 C0,5.39149449 5.39149449,0 12.04224,0 C18.6929855,0 24.08448,5.39149449 24.08448,12.04224 C24.08448,18.6929855 18.6929855,24.08448 12.04224,24.08448 Z M12.04224,21.82656 C17.4459707,21.82656 21.82656,17.4459707 21.82656,12.04224 C21.82656,6.63850928 17.4459707,2.25792 12.04224,2.25792 C6.63850928,2.25792 2.25792,6.63850928 2.25792,12.04224 C2.25792,17.4459707 6.63850928,21.82656 12.04224,21.82656 Z",
    id: "Shape",
    fill: "#3E3832",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0060722,19.2534322 C20.589315,18.6701893 21.5349386,18.6701893 22.1181814,19.2534322 L32.6787278,29.8139786 C33.2619707,30.3972214 33.2619707,31.342845 32.6787278,31.9260878 C32.095485,32.5093307 31.1498614,32.5093307 30.5666186,31.9260878 L20.0060722,21.3655414 C19.4228293,20.7822986 19.4228293,19.836675 20.0060722,19.2534322 Z",
    id: "Rectangle",
    fill: "#3E3832",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C2EAF7",
    fillRule: "nonzero",
    opacity: 0.495117188,
    cx: 12.04224,
    cy: 12.04224,
    r: 9.78432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03168,18.3355611 C9.73614291,18.6047032 10.4939021,18.7511011 11.2831645,18.7511011 C15.0271169,18.7511011 18.0621899,15.4568795 18.0621899,11.3932511 C18.0621899,8.83835788 16.8624511,6.58760461 15.0410991,5.26848 C17.678333,6.27604249 19.56864,9.00381496 19.56864,12.21079 C19.56864,16.2744184 16.533567,19.56864 12.7896146,19.56864 C11.3995681,19.56864 10.1072387,19.1145407 9.03168,18.3355611 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedigeStillinger);
export default __webpack_public_path__ + "static/media/LedigeStillinger.7e94c78ab4ab4e97daacaf7ecdf16ac2.svg";
export { ForwardRef as ReactComponent };